import { ENGAGE_CHANNEL, SCRATCHCARD_TOPIC, WHEEL_OF_FORTUNE_TOPIC } from '@spilnu/game-comms'
import type { PromotionClient } from '@core/types'

interface EngageGame {
    path: string
    channel: typeof ENGAGE_CHANNEL[keyof typeof ENGAGE_CHANNEL]
    topic: typeof SCRATCHCARD_TOPIC | typeof WHEEL_OF_FORTUNE_TOPIC
}

export const ENGAGE_GAMES: Partial<Record<PromotionClient.BonusType, EngageGame>> = {
    SCRATCHCARDS: { path: '/engage/scratchcard', channel: ENGAGE_CHANNEL.scratchcard, topic: SCRATCHCARD_TOPIC },
    WHEEL_OF_FORTUNE: { path: '/engage/wheel_of_fortune', channel: ENGAGE_CHANNEL.wheelOfFortune, topic: WHEEL_OF_FORTUNE_TOPIC },
    // Engage's reveal page publishes on the scratchcard channel.
    DROP_THE_BALL: { path: '/engage/reveal', channel: ENGAGE_CHANNEL.scratchcard, topic: SCRATCHCARD_TOPIC },
}
